export enum frequencyState {
  day = 1,
  week = 2,
  month = 3,
}

export enum ActionState {
  just_record = 1,
  stop_blocking = 2,
  record_warning = 3,
}
export enum DirectionState {
  bidirectional = 1,
  inbound = 2,
  outbound = 3,
}
export enum ProtocolState {
  arbitrary_agreement = 1,
  TCP = 2,
  UDP = 3
}
export enum PortTypeState {
  normal_port = 2,
  custom_port = 1,
}
export const localPortLabel = [
  {
    label: '20', value: '20', subtitle: 'FTP 数据传输端口',
  },
  {
    label: '21', value: '21', subtitle: 'FTP 文件传输协议',
  },
  {
    label: '22', value: '22', subtitle: 'SSH 远程登录会话',
  },
  {
    label: '23', value: '23', subtitle: 'Telnet 远程登录服务',
  },
  {
    label: '25', value: '25', subtitle: 'SMTP 邮件传输协议',
  },
  {
    label: '53', value: '53', subtitle: 'DNS 域名服务器',
  },
  {
    label: '67', value: '67', subtitle: 'DHCP 服务器端口号',
  }, {
    label: '68', value: '68', subtitle: 'DHCP 客户机端口号',
  },
  {
    label: '69', value: '69', subtitle: 'TFTP 文件传输协议',
  }, {
    label: '79', value: '79', subtitle: 'Finger 服务',
  },
  {
    label: '80', value: '80', subtitle: 'HTTP超文本传输协议',
  }, {
    label: '110', value: '110', subtitle: 'POP3 邮件协议服务',
  },
  {
    label: '111', value: '111', subtitle: 'RPC 远程过程调用服务',
  },
  {
    label: '113', value: '113', subtitle: 'Windows 身份验证服务',
  },
  {
    label: '119', value: '119', subtitle: 'NNTP 网络新闻传输协议',
  },
  ...[
    {
      "label": "135",
      "value": '135',
      "subtitle": "RPC远程过程调用服务"
    },
    {
      "label": "137",
      "value": '137',
      "subtitle": "NetBIOS 名称服务"
    },
    {
      "label": "138",
      "value": '138',
      "subtitle": "UDP 端口"
    },
    {
      "label": "139",
      "value": '139',
      "subtitle": "NetBIOS 与 Samba 服务"
    },
    {
      "label": "143",
      "value": '143',
      "subtitle": "IMAP 邮件服务协议"
    },
    {
      "label": "161",
      "value": '161',
      "subtitle": "SNMP 网络管理协议"
    },
    {
      "label": "177",
      "value": '177',
      "subtitle": "X Display Manager Control Protocol"
    },
    {
      "label": "389",
      "value": '389',
      "subtitle": "目录访问协议"
    },
    {
      "label": "443",
      "value": '443',
      "subtitle": "HTTPS 网页浏览端口"
    },
    {
      "label": "445",
      "value": '445',
      "subtitle": "Microsoft 文件共享"
    },
    {
      "label": "513",
      "value": '513',
      "subtitle": "远程登录端口"
    },
    {
      "label": "635",
      "value": '635',
      "subtitle": "Mountd 端口"
    },
    {
      "label": "993",
      "value": '993',
      "subtitle": "IMAP 端口"
    },
    {
      "label": "1024",
      "value": '1024',
      "subtitle": "Reserved 端口"
    },
    {
      "label": "1080",
      "value": '1080',
      "subtitle": "Socks 代理服务端口"
    },
    {
      "label": "1158",
      "value": '1158',
      "subtitle": "Oracle EMCTL"
    },
    {
      "label": "1433",
      "value": '1433',
      "subtitle": "SQL 服务开启此端口"
    },
    {
      "label": "1521",
      "value": '1521',
      "subtitle": "Oracle 数据库"
    },
    {
      "label": "1524",
      "value": '1524',
      "subtitle": "Ingress 端口"
    },
    {
      "label": "1720",
      "value": '1720',
      "subtitle": "NetMeeting 端口"
    },
    {
      "label": "1731",
      "value": '1731',
      "subtitle": "NetMeeting 音频调用控制端口"
    },
    {
      "label": "1732",
      "value": '1732',
      "subtitle": "PPTP VPN"
    },
    {
      "label": "2049",
      "value": '2049',
      "subtitle": "NFS 程序运行端口"
    },
    {
      "label": "2500",
      "value": '2500',
      "subtitle": "应用固定会话端口"
    },
    {
      "label": "3128",
      "value": '3128',
      "subtitle": "Squid HTTP 代理服务器端口"
    },
    {
      "label": "3210",
      "value": '3210',
      "subtitle": "SchoolBus 开启此端口"
    },
    {
      "label": "3306",
      "value": '3306',
      "subtitle": "MYSQL 数据库"
    },
    {
      "label": "3333",
      "value": '3333',
      "subtitle": "Prosiak 开启此端口"
    },
    {
      "label": "3389",
      "value": '3389',
      "subtitle": "远程桌面"
    },
    {
      "label": "3700",
      "value": '3700',
      "subtitle": "Portal of Doom 开启此端口"
    },
    {
      "label": "3996",
      "value": '3996',
      "subtitle": "RemoteAnything 开启此端口"
    },
    {
      "label": "4000",
      "value": '4000',
      "subtitle": "腾讯QQ客户端 开启此端口"
    },
    {
      "label": "4060",
      "value": '4060',
      "subtitle": "RemoteAnything 开启此端口"
    },
    {
      "label": "4321",
      "value": '4321',
      "subtitle": "SchoolBus 开启此端口"
    },
    {
      "label": "5900",
      "value": '5900',
      "subtitle": "VNC 服务器"
    },
    {
      "label": "5000",
      "value": '5000',
      "subtitle": "blazer5开启5000端口"
    },
    {
      "label": "5632",
      "value": '5632',
      "subtitle": "pcAnywere 端口"
    },
    {
      "label": "5672",
      "value": '5672',
      "subtitle": "rabbitMQ"
    },
    {
      "label": "6379",
      "value": '6379',
      "subtitle": "Redis 数据库端口"
    },
    {
      "label": "6670",
      "value": '6670',
      "subtitle": "Deep Throat 开启此端口"
    },
    {
      "label": "6671",
      "value": '6671',
      "subtitle": "Deep Throat 3.0 开启此端口"
    },
    {
      "label": "6970",
      "value": '6970',
      "subtitle": "RealAudio 接收音频数据流端口"
    },
    {
      "label": "7001",
      "value": '7001',
      "subtitle": "WebLogic"
    },
    {
      "label": "7323",
      "value": '7323',
      "subtitle": "Sygate 服务器端口"
    },
    {
      "label": "8080",
      "value": '8080',
      "subtitle": "Tomcat"
    },
    {
      "label": "8081",
      "value": '8081',
      "subtitle": "HTTP 协议代理服务器端口"
    },
    {
      "label": "9080",
      "value": '9080',
      "subtitle": "WebSphere 应用程序"
    },
    {
      "label": "9090",
      "value": '9090',
      "subtitle": "WebSphere 管理工具"
    },
    {
      "label": "9098",
      "value": '9098',
      "subtitle": "HTTP 协议代理服务器端口"
    },
    {
      "label": "17027",
      "value": '17027',
      "subtitle": "Conducent 端口"
    },
    {
      "label": "19132",
      "value": '19132',
      "subtitle": "Minecraft PE 默认开服端口"
    },
    {
      "label": "25565",
      "value": '25565',
      "subtitle": "Minecraft PC 默认开服端口"
    }
  ]
]

